import {Component, Input} from '@angular/core';
import {Router, ActivatedRoute, UrlTree, IsActiveMatchOptions} from '@angular/router';

const EXACT_MATCH: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

@Component({
    selector: 'app-horizontal-menu',
    templateUrl: './horizontal-menu.component.html',
    styleUrls: ['./horizontal-menu.component.scss'],
    standalone: false
})
export class HorizontalMenuComponent {
  @Input() items: MenuItem[] = [];
  @Input() baseRoute: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  getLink(item: MenuItem): any[] {
    return item.disabled ? [] : [...this.baseRoute, ...item.route];
  }

  isActive(item: MenuItem): boolean {
    if (item.disabled) {
      return false;
    }
    const tree: UrlTree = this.router.createUrlTree(this.getLink(item), {relativeTo: this.route});
    return this.router.isActive(tree, EXACT_MATCH);
  }
}

export interface MenuItem {
  title: string;
  route: any[];
  disabled?: boolean;
}
